export default "__VITE_ASSET__BcgqfD8f__"